import React from "react";
import { useNavigate } from 'react-router-dom';
import theme1 from "../Components/Themes/Theme1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { SvgBackground ,BackIcon} from "../Components/Themes/Theme1";
const Intro4 = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/intro3'); // Replace with the correct path to Intro3
  };
  const handleBeginClick = () => {
    navigate('/');
  }
  return (
<div
  className="min-h-screen w-full flex flex-col items-center justify-center relative z-10"
    style={{
      backgroundImage: "url('/images/background.svg')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }}
  >
      {/* SVG Background */}
      {/* <SvgBackground className="absolute inset-0 w-full h-full -z-10 object-cover" /> */}
  
      {/* Back Button */}
      <div className="absolute top-6 left-6 sm:top-8 sm:left-8 md:top-10 md:left-10 lg:top-12 lg:left-12 z-20">
        <button
          className="flex items-center justify-center hover:bg-gray-100 transition px-3 py-2 rounded-lg"
          onClick={handleBackClick}
        >
        {/* Back Icon as a background image */}
        <span
          className="w-4 h-4 sm:w-8 sm:h-8 md:w-6 md:h-6"
          style={{
            backgroundImage: "url('/images/Back-icon.svg')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "inline-block",
          }}
        ></span>

        {/* Back Text */}
        <span
          className="ml-2 text-sm sm:text-base md:text-lg"
          style={{ fontFamily: "'Archivo', sans-serif" }}
        >
          Back
        </span>
      </button>
    </div>

      {/* Heading */}
      <h1
        className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center text-[#002952] mb-6 z-20"
        style={{ fontFamily: "'Archivo', sans-serif" }}
      >
        Great! Successfully Onboarded
      </h1>
  
      {/* GIF */}
      <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-80 lg:h-80 mb-6 z-20">
        <img
          src="images/success.gif"
          alt="Learning GIF"
          className="w-full h-full object-contain"
        />
      </div>
  
      {/* Button */}
      <button
        className="bg-[#2563EB] hover:bg-[#1E40AF] text-white text-sm sm:text-lg md:text-xl font-semibold py-3 px-8 sm:py-4 sm:px-12 rounded-full shadow-lg transition transform hover:scale-105 z-20"
        onClick={handleBeginClick}
      >
        I'M READY TO LEARN
      </button>
    </div>
  );
};

export default Intro4;
